RivalIQ.apps.Alerts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;
    const Widget = Dashboard.models.Widget;

    const AlertsWidget = Widget.extend({
        title: 'Alert Feed',
        exportTitle: 'Alerts',
        description: RivalIQ.strings.alerts_info,
        getExportSubtitle: function () {
            const me = this;
            if (me.isFocus()) {
                const timezone = RivalIQ.state.landscape.get('timezone') || 'UTC';
                return RivalIQ.utils.timePeriod.getTimePeriodDisplayString(me.getProp('timePeriod'), true, timezone);
            }
        },
        view: App.views.Alerts,
        viewMore: false,
        allowPageBreaks: true,
        exportFormats: [
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PPT
        ],

        getVisualExportLimit: Dashboard.widgets.TableWidget.prototype.getVisualExportLimit,
        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                limit: (me.isFocus() ? -1 : 3)
            });

            if (!_.isUndefined(props.source)) {
                if (props.source === RivalIQ.enums.sources.CROSS_CHANNEL) {
                    props.activeSources = me.curation.getProp('activeSources');
                } else {
                    props.activeSources = RivalIQ.enums.sourceDetails[props.source].sourceMask;
                }
            }

            return props;
        },

        processExportProps: function (props, changed) {
            const me = this;
            props.limit = me.getVisualExportLimit(props);
            return me.processProps(props, changed);
        },

        isSupported: _.constant(true),
        supportedProps: {
            searchTerm: false,
            interval: false,
            type: false,
            metrics: false
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.ALERTS, AlertsWidget);
});
